Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};
Greenmile.Task.RelatedInfo.Survey = {

    removeLinkedSurveyFromList: function (el) {

        var lineItem = el.parentNode.parentNode.parentNode.parentNode;

        if (lineItem.className === 'controls') {
            lineItem = el.parentNode.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;

        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedSurveyFromData: function (el) {

        var node = el.parentNode.parentNode;
        var nodes = Monet.Session.Task.lastLinkForm.surveys.nodes;
        var ids = Monet.Session.Task.lastLinkForm.surveys.ids;
        var data = Monet.Session.Task.lastLinkForm.surveys.data;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {
            if (nodes[i].id === node.id) {
                index = i;
                break;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.surveys.splice(index, 1);
        }

    },

    createSurveyIdNode: function (data) {

        var divContainer = document.createElement('div');
        var divTitle = document.createElement('div');
        var divDel = document.createElement('div');
        var divDestroy = document.createElement('div');
        var divClear = document.createElement('div');
        var inputStatus = document.createElement('input');
        var inputLinked = document.createElement('input');
        var input = document.createElement('input');
        var linkedTaskWhen = document.createElement('input');

        divContainer.id = "survey_" + data.survey.id;
        divContainer.className = "item_lookuplist_survey_" + data.survey.id;

        divTitle.className = "title_item_added";
        divTitle.appendChild(document.createTextNode(data.survey.title));

        divDel.className = "del_item_added";

        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";
        divClear.style.clear = "both";

        divDestroy.addEventListener('click', (function (scope, data) {

            return function (e) {

                e.preventDefault();

                const confirmDeleteSurvey = () => {
                    App.Views.Task.showLoadingElement(this);
                    Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                        return function () {

                            App.Views.Task.hideLoad();

                            scope.removeLinkedSurveyFromList(e.target);
                            scope.removeLinkedSurveyFromData(e.target, scope);
                            Greenmile.Task.RelatedInfo
                                .removeTitleContainerIfEmptyTo(
                                    Greenmile.Task.RelatedInfo.collections.SURVEYS
                                );
                        };
                    }(e)));
                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteSurvey);

            };

        }(this, data)));

        linkedTaskWhen.type = 'hidden';
        linkedTaskWhen.id = "taskLinkeds[" + data.survey.id + "].when";
        linkedTaskWhen.name = "taskLinkeds[" + data.survey.id + "].when";
        linkedTaskWhen.className = "modelAttribute";
        linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

        input.type = "hidden";
        input.name = "taskLinkeds[" + data.survey.id + "].survey.id";
        input.id = "taskLinkeds[" + data.survey.id + "].survey.id";
        input.className = "modelAttribute";
        input.value = data.survey.id;

        inputStatus.type = 'hidden';
        inputStatus.name = 'taskLinkeds[' + data.survey.id + '].status';
        inputStatus.id = 'taskLinkeds[' + data.survey.id + '].status';
        inputStatus.className = "modelAttribute";
        inputStatus.value = '';

        inputLinked.type = 'hidden';
        inputLinked.name = 'taskLinkeds[' + data.survey.id + '].id';
        inputLinked.id = 'taskLinkeds[' + data.survey.id + '].id';
        inputLinked.className = "modelAttribute";
        inputLinked.value = data.id || '';

        divDel.appendChild(divDestroy);

        divContainer.appendChild(divTitle);
        divContainer.appendChild(divDel);
        divContainer.appendChild(divClear);
        divContainer.appendChild(input);
        divContainer.appendChild(inputStatus);
        divContainer.appendChild(inputLinked);
        divContainer.appendChild(linkedTaskWhen);

        Monet.Session.Task.lastLinkForm.surveys.nodes.push(divContainer);
        Monet.Session.Task.lastLinkForm.surveys.data.push(data);
        Monet.Session.Task.lastLinkForm.surveys.ids.push(input);

    },

    createFullSurveyInfo: function (data) {
        Monet.Session.Task.lastLinkForm.surveys.nodes = [];
        Monet.Session.Task.lastLinkForm.surveys.data = [];
        Monet.Session.Task.lastLinkForm.surveys.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('survey')) {
                this.createSurveyIdNode(data[i]);
            }

        }

    }

};